// You can include shared interfaces/types in a separate file
// and then use them in any component by importing them. For
// example, to import the interface below do:
//
// import { User } from 'path/to/interfaces';
import { useRouter } from 'next/router';

export type User = {
  id: string;
  verified: boolean;
  phoneNumber: string;
};

export const APOLLO_STATE_PROP_NAME = '__APOLLO_STATE__';

export type ParsedUrlQuery = ReturnType<typeof useRouter>['query'];
